<template>
  <b-card-group v-if="!finished" deck class="time-remaining">
    <b-card class="text-center" :class="{'red-condicional' : color}" bg-variant="light" header="Tiempo restante" >
      <b-card-text ><span v-if="displayHours !== '00'">{{displayHours}}:</span>{{displayMinutes}}:{{displaySeconds}}</b-card-text>
      <br>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  name: "TimeRemain",
  props: ["timeRemain"],
  components: {
  },
  data:() => {
    return {
      finished: false,
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      color: false,
      _timer: null,
      _alertEmitted: false,
    }
  },
  beforeDestroy() {
    if (this._timer) clearInterval(this._timer);
  },
  methods: {
    tick() {
      const now = new Date();
      const end = new Date(this.timeRemain);
      let offset = new Date().getTimezoneOffset() * 60000;
      if (import.meta.env.VITE_TEST_MODE === "true") {
        offset = 0;
      }
      const distance = end.getTime() - now.getTime() - offset;

      if (distance <= 0) {
        if (this._timer) {
          clearInterval(this._timer);
          this._timer = null;
        }
        this.finished = true;
        if (!this._alertEmitted) {
          this._alertEmitted = true;
          this.$emit("alertFinish");
        }
        return;
      }

      if (distance <= 300000) {
        this.color = true;
      }

      const days = Math.floor(distance / this._days);
      const hours = Math.floor((distance % this._days) / this._hours);
      const minutes = Math.floor((distance % this._hours) / this._minutes);
      const seconds = Math.floor((distance % this._minutes) / this._seconds);

      this.displayMinutes = minutes < 10 ? "0" + minutes.toString() : minutes;
      this.displaySeconds = seconds < 10 ? "0" + seconds : seconds;
      this.displayHours = hours < 10 ? "0" + hours : hours;
      this.displayDays = days < 10 ? "0" + days : days;
    },
    showRemaining() {
      this.tick();
      this._timer = setInterval(() => this.tick(), 1000);
    },
  },
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },


  },
  mounted() {
    this.showRemaining()
  }
};
</script>

<style scoped>

</style>
